import { IconVehicle, IconDeliveryInProgress, IconDelivered } from "icons";

const statusIcons = {
  0: IconVehicle,
  1: IconDeliveryInProgress,
  2: IconDelivered,
};

export default statusIcons;
